import { render, staticRenderFns } from "./branchesEdit.vue?vue&type=template&id=59fbd7d8&scoped=true"
import script from "./branchesEdit.vue?vue&type=script&lang=js"
export * from "./branchesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fbd7d8",
  null
  
)

export default component.exports